import { type ReactElement } from 'react';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useNotificationStore } from '@/store/notification.store';

function toastVariant(
  type: 'success' | 'error' | 'warning' | 'info'
): 'default' | 'destructive' | 'warning' {
  if (type === 'error') {
    return 'destructive';
  }
  if (type === 'warning') {
    return 'warning';
  }
  return 'default';
}

export function Toaster(): ReactElement {
  const notifications = useNotificationStore((state) => state.notifications);
  const removeNotification = useNotificationStore((state) => state.removeNotification);

  return (
    <ToastProvider>
      {notifications.map((notification) => (
        <Toast
          key={notification.id}
          duration={notification.duration ?? 5000}
          variant={toastVariant(notification.type)}
          onOpenChange={(open) => {
            if (!open) {
              removeNotification(notification.id);
            }
          }}
        >
          <ToastTitle>
            {notification.type.charAt(0).toUpperCase() + notification.type.slice(1)}
          </ToastTitle>
          <ToastDescription>{notification.message}</ToastDescription>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
